import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=9cd93dfe&scoped=true&"
import script from "./knowledge.vue?vue&type=script&lang=js&"
export * from "./knowledge.vue?vue&type=script&lang=js&"
import style0 from "./knowledge.vue?vue&type=style&index=0&id=9cd93dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd93dfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cd93dfe')) {
      api.createRecord('9cd93dfe', component.options)
    } else {
      api.reload('9cd93dfe', component.options)
    }
    module.hot.accept("./knowledge.vue?vue&type=template&id=9cd93dfe&scoped=true&", function () {
      api.rerender('9cd93dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/print/components/knowledge.vue"
export default component.exports